/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_CreatingInputs */

const en_admin_invite_codes_creating = /** @type {(inputs: Admin_Invite_Codes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating...`)
};

/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {Admin_Invite_Codes_CreatingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_creating = /** @type {((inputs?: Admin_Invite_Codes_CreatingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_CreatingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_creating(inputs)
});
export { admin_invite_codes_creating as "admin.invite_codes.creating" }